<template>
  <div class="booking-status">
    <div class="row">
      <p class="col-xs-12">
        <span v-if="bookingTypeIsBooking">Booking #{{ booking.id | padded('0', 5) }}</span>

        <booking-status-label :booking="booking" />

        <span v-if="booking.urgent" class="status status-bad">Urgent</span>
      </p>
    </div>
    <div class="row">
      <div v-if="$userIsAdmin && (bookingIsCancelled || bookingIsWithdrawn)" class="col-xs-12">
        <p class="pull-right">Withdraw Reason: {{ bookingWithdrawReason }}</p>
        <p v-if="!booking.talent.length">Note: No {{ $declineModuleEnabled ? $t('Applied') : 'Accepted' }} Stars</p>
      </div>
      <div v-if="$userIsAdmin && bookingIsDeclined && bookingWithdrawReason" class="right col-xs-12">
        <p>Decline Reason: {{ bookingWithdrawReason }}</p>
        <p v-if="!booking.talent.length">Note: No {{ $declineModuleEnabled ? $t('Applied') : 'Accepted' }} Stars</p>
      </div>
    </div>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import BookingStatusLabel from './BookingStatusLabel'

export default {
  components: {BookingStatusLabel},
  mixins: [helpers],

  props: {
    booking: {
      type: Object,
      required: true
    }
  }
}
</script>
